let { View } = window.App;
import SplitText from './split-text';
import Isotope   from 'isotope-layout';

const SELECTOR = '.js-articles-list';

class ArticlesList{
    constructor( el ){
        this.el = el;
        this.$el = $( el );

        this._loading = false;

        this.bindElements();

        this.Isotope = new Isotope( this.$content.get( 0 ), {
            transitionDuration: 0,
        } );
    }

    get loading(){
        return this._loading;
    }

    set loading( value ){
        this._loading = value;
        this.$el.toggleClass( "__articles-loading", value );
    }

    bindElements(){
        this.$load_more = this.$el.find( SELECTOR + '__load-more' );
        this.$load_more_button = this.$el.find( SELECTOR + '__load-more-button' );
        this.$content = this.$el.find( SELECTOR + '__content' );

        this.$load_more_button.on( 'click', $.proxy( this.onLoadMoreClick, this ) );
    }

    onLoadMoreClick( e ){
        e.preventDefault();

        if( !this.loading ){
            this.load( e.currentTarget.href );
        }
    }

    load( url ){
        this.loading = true;
        $.get( url, response => {
            this.loading = false;
            let $html = $( response );


            let $loaded_articles = $html.find( SELECTOR + '__content' ).children(),
                $load_more = $html.find( SELECTOR + '__load-more' );

            this.$content.append( $loaded_articles );
            this.$load_more.replaceWith( $load_more );

            $loaded_articles.add( $load_more ).find( '.btn' ).each( function(){
                new SplitText( this )
            } );

            this.Isotope.appended( $loaded_articles );

            this.bindElements();
        } );
    }
}

View.addHook( 'init', v => {
    v.$( SELECTOR ).each( function(){
        new ArticlesList( this );
    } );
} )



// WEBPACK FOOTER //
// ./resources/js/modules/articles-list.js